<template>
  <b-card no-body>
    <b-col
      cols="12"
      md="6"
      class="text-left"
    >
      <b-form-group
        label="Ara"
        label-for="search"
      >
        <b-form-input
          id="search"
          v-model="search"
          placeholder="Ara"
          @keyup.enter="searchVal(search)"
        />
      </b-form-group>
    </b-col>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
      fixed
    >
      <template #cell(title)="data">
        <div>{{ data.item.title }}</div>
        <div class="text-primary font-small-2">
          {{ data.item.group_name }}
        </div>
      </template>
      <template #cell(control)="data">
        <div class="text-right">
          <b-button
            variant="flat-primary"
            size="sm"
            :to="$route.path + '/data-list/en/' + data.item.id"
          >
            <FeatherIcon icon="ArchiveIcon" /> İngilizce
          </b-button>
        </div>
      </template>
    </b-table>
  </b-card>
</template>
<script>
import {
  BCard, BTable, BButton, BFormGroup, BCol, BFormInput,
} from 'bootstrap-vue'

const tableName = 'translate_forms'
export default {
  name: 'Index',
  components: {
    BFormInput,
    BCol,
    BFormGroup,
    BCard,
    BTable,
    BButton,
  },
  data() {
    return {
      search: '',
      fields: [
        {
          key: 'title',
          label: 'BAŞLIK',
        },
        {
          key: 'control',
          label: '',
          thStyle: { width: '200px' },
        },
      ],
      dataQuery: { // veri alınacak sorgu
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
          `${tableName}.group_name AS group_name`,
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['translate/dataList']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    searchVal(val) {
      const sanitizedVal = val ? val.replace(/'/g, "''") : ''
      this.dataQuery.where = sanitizedVal ? `(title LIKE '%${sanitizedVal}%' OR group_name LIKE '%${sanitizedVal}%')` : ''
      this.getDataList()
    },
    getDataList() {
      this.$store.dispatch('translate/getIndexList', this.dataQuery)
    },
  },
}
</script>
